<template>
  <v-tooltip bottom>
    <v-btn
      slot="activator"
      :aria-label="$t('Delete')"
      :disabled="disabled"
      class="ma-0 error--text"
      icon
      @click="$emit('click')">
      <v-icon>delete</v-icon>
    </v-btn>
    <span>{{ $t('Delete') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
